import i18next from 'i18next';
import { useMemo } from 'react';

import CodeCol from './code';
import s from './styles.module.scss';
import StatusCol from './status';
import OptionsCol from './options';

import type { ClinicInvoice } from 'infrastructure/classes/clinic-invoice/clinic-invoice';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

interface IProps {
  isEdit: boolean;
  onEdit: (rec: ClinicInvoice) => void;
  onSave: (rec: ClinicInvoice) => void;
}

export const columns = ({
  isEdit,
  onEdit,
  onSave,
}: IProps): IBaseTableColumns<ClinicInvoice> => {
  const items = useMemo<IBaseTableColumns<ClinicInvoice>>(() => {
    const cols: IBaseTableColumns<ClinicInvoice> = [
      {
        label: i18next.t('labels.serviceType'),
        key: 'serviceType',
        width: '140px',
        render: (_, r) => (
          <span className={s.type}>
            {i18next.t(`clinicInvoiceServiceTypes.${r.serviceType}`)}
          </span>
        ),
      },
      {
        label: i18next.t('labels.code'),
        key: 'code',
        width: '200px',
        render: (_, r) => <CodeCol code={r.code} name={r.name} />,
      },
      {
        label: i18next.t('labels.description'),
        key: 'description',
      },
      {
        label: i18next.t('labels.billingType'),
        key: 'billingType',
        width: '135px',
        render: (_, r) => (
          <span>{i18next.t(`clinicInvoiceBillingTypes.${r.billingType}`)}</span>
        ),
      },
      {
        label: i18next.t('labels.productPrice'),
        key: 'productPrice',
        width: '120px',
        align: 'right',
        render: (_, r) => <span className={s.type}>${r.price}</span>,
      },
      {
        label: i18next.t('labels.status'),
        key: 'status',
        width: '100px',
        render: (_, r) => <StatusCol data={r} />,
      },
    ];

    if (isEdit) {
      cols.push({
        label: i18next.t('labels.options'),
        key: 'options',
        width: '85px',
        align: 'center',
        render: (_, r) => <OptionsCol onEdit={() => onEdit(r)} />,
      });
    }
    return cols;
  }, [isEdit, onEdit, onSave]);

  return items;
};
